import React from 'react';
import { Tag, Tooltip } from 'antd';
import { Influencer } from '../../../../services/marketingAPI';

export const RegistrationTimeCell: React.FC<{ record: Influencer }> = ({ record }) => {
    const mainProfile = (record.profiles || []).sort((a, b) => b.follower_count - a.follower_count)[0];
    if (!mainProfile || !mainProfile.join_date) return <span>-</span>;

    let joinDateStr = mainProfile.join_date;
    if (joinDateStr.includes('年')) {
        joinDateStr = joinDateStr.replace(/年/g, '-').replace(/月/g, '-').replace(/日/g, '');
    }
    const joinDate = new Date(joinDateStr);
    const now = new Date();

    if (isNaN(joinDate.getTime())) return <span>{mainProfile.join_date}</span>;

    const diffTime = Math.abs(now.getTime() - joinDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    const dateFmt = joinDate.toLocaleDateString('zh-CN', { year: 'numeric', month: 'numeric', day: 'numeric' });

    return (
        <div style={{ fontSize: '13px' }}>
            <span style={{ fontWeight: 'bold', color: '#1890ff' }}>{diffDays}天</span>
            <div style={{ color: '#888', fontSize: '12px' }}>({dateFmt})</div>
        </div>
    );
};

export const UpdateFrequencyCell: React.FC<{ record: Influencer }> = ({ record }) => {
    const mainProfile = (record.profiles || []).sort((a, b) => b.follower_count - a.follower_count)[0];
    if (!mainProfile || !mainProfile.join_date || !mainProfile.video_count || mainProfile.video_count === 0) return <span style={{ color: '#ccc' }}>-</span>;

    let joinDateStr = mainProfile.join_date;
    if (joinDateStr.includes('年')) {
        joinDateStr = joinDateStr.replace(/年/g, '-').replace(/月/g, '-').replace(/日/g, '');
    }

    const joinDate = new Date(joinDateStr);
    const checkDate = new Date(mainProfile.updated_at || new Date());

    if (isNaN(joinDate.getTime())) return <span>-</span>;

    const diffTime = Math.abs(checkDate.getTime() - joinDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays <= 0) return <span>-</span>;

    const daysPerVideo = (diffDays / mainProfile.video_count).toFixed(1);

    return (
        <Tooltip title={`注册于 ${new Date(joinDate).toLocaleDateString()}，共 ${diffDays} 天`}>
            <div style={{ fontSize: '12px' }}>{daysPerVideo} 天/更</div>
        </Tooltip>
    );
};

export const LastUpdatedCell: React.FC<{ record: Influencer }> = ({ record }) => {
    const mainProfile = (record.profiles || []).sort((a, b) => b.follower_count - a.follower_count)[0];
    const dateStr = mainProfile?.updated_at || record.updated_at;
    if (!dateStr) return <span>-</span>;
    return <div style={{ fontSize: '12px', color: '#888' }}>{new Date(dateStr).toLocaleDateString()}</div>;
};
